"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var SearchFilters = props => {
  var handleOnChange = event => {
    var urlPath = props.scfields.searchUrl.value;
    if (event.target.value.toLowerCase() !== 'all') {
      if (event.target.checked) {
        var val = props.curlist === undefined ? event.target.value : props.curlist.trim().length === 0 ? event.target.value : props.curlist.concat("|".concat(event.target.value));
        window.history.pushState({
          path: "".concat(urlPath, "?query=").concat(props.searchterm, "&type=").concat(val, "&page=1")
        }, '', "".concat(urlPath, "?query=").concat(props.searchterm, "&type=").concat(val, "&page=1"));
      } else {
        var fullpath = '';
        var rmFilter = props.curlist.replace("|".concat(event.target.value), '').replace(event.target.value, '').trim();
        if (rmFilter.length) {
          rmFilter = rmFilter[0] === '|' ? rmFilter.slice(1) : rmFilter;
          fullpath = urlPath + "?query=".concat(props.searchterm, "&type=").concat(rmFilter, "&page=1");
        } else {
          fullpath = urlPath + "?query=".concat(props.searchterm, "&page=1");
        }
        window.history.pushState({
          path: fullpath
        }, '', fullpath);
      }
      props.onSelect(event.target.value, event.target.checked);
    } else {
      window.history.pushState({
        path: "".concat(urlPath, "?query=").concat(props.searchterm, "&page=1")
      }, '', "".concat(urlPath, "?query=").concat(props.searchterm, "&page=1"));
      props.onAllSelect(event.target.value, event.target.checked);
    }
  };
  var checkedMap = (key, list) => {
    var res = false;
    var filters = !list || list.length === 0 ? [] : list.split('|');
    filters.forEach(function (itm, index) {
      if (key.toLowerCase() === itm.toLowerCase()) {
        res = true;
      }
    });
    return res;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    id: props.scfields.Filterlist.id,
    className: "app-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card-text"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "space-above-xs space-below-none"
  }, /*#__PURE__*/_react.default.createElement("h3", null, props.scfields.filterText.value), /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-unstyled"
  }, /*#__PURE__*/_react.default.createElement("li", {
    className: "custom-control custom-checkbox"
  }, /*#__PURE__*/_react.default.createElement("input", {
    className: "custom-control-input",
    type: "checkbox",
    id: "custbox999",
    name: "all",
    value: "all",
    checked: !props.curlist || props.curlist.length === 0 ? true : false,
    onChange: handleOnChange
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "custom-control-label",
    htmlFor: "custbox999"
  }, "All Results")), (0, _lodash.map)(props.filteritms, (item, index) => {
    var scindex = props.scfields.Filterlist.findIndex(f => f.name.toLowerCase() === item.facettitle.toLowerCase());
    if (scindex !== -1) {
      var scItemValue = props.scfields.Filterlist[scindex].fields.Value.value;
      return /*#__PURE__*/_react.default.createElement("li", {
        key: "fkey".concat(item.facetdescription, "_").concat(index),
        className: "custom-control custom-checkbox"
      }, /*#__PURE__*/_react.default.createElement("input", {
        className: "custom-control-input",
        type: "checkbox",
        id: "custbox".concat(index),
        name: item.facettitle,
        value: item.facettitle,
        checked: checkedMap(item.facettitle, props.curlist),
        onChange: handleOnChange
      }), /*#__PURE__*/_react.default.createElement("label", {
        className: "custom-control-label",
        htmlFor: "custbox".concat(index)
      }, " ", scItemValue, " - ", item.facetdescription));
    }
  })))))));
};
var _default = exports.default = SearchFilters;